import React, { useRef } from 'react';

import { ExtendedContentTools } from 'components/ExtendedContent/ExtendedContentTools';
import { ExtendedContentCanvas } from 'components/ExtendedContent/ExtendedContentCanvas';
import { ExtendedPinchPanContainer } from 'components/ExtendedPinchPanContainer';
import DrawArea from 'components/DrawArea';
import { ExtendedContentEvent } from '../ExtendedContentEvent';
import { EventBusType } from 'events/EventBus';
import { useStore, StoreTypes } from 'context';
import { useExtendedZoom } from 'customHooks/extendedZoom';
import classnames from 'classnames';
import styles from './index.module.scss';

const eventBusType = EventBusType.ExtendedContent;

export const ExtendedHtmlContentContainer = ({ children ,toolbarOpen}) => {
    const contentView = useRef();
    const [
        { canvasState, canvasHeight, canvasWidth, isContentInit, svgContent, toolType },
        { canvasDispatch }
    ] = ExtendedContentEvent(contentView);
    const [{ drawAreaInfo }] = useStore(StoreTypes.extendedContent);

    // 四格放大 / 區間放大 / 原尺寸：註冊縮放事件，實際的 transform 由下方的
    // ExtendedPinchPanContainer 執行，框選層則是 DrawArea（NBK-1639）。
    useExtendedZoom({ contentView, eventBusType });

    const getCanvasSvg = str => {
        str = str.replace('<svg', '<svg preserveAspectRatio="xMidYMid"');
        return str;
    };

    return (
        <div id="exHtmlContainer" className={classnames(styles.extendedContentContainer, styles[`cursor${toolType}`])}>
            {drawAreaInfo && drawAreaInfo.isDrawArea && (
                <DrawArea drawAreaInfo={drawAreaInfo} eventBusType={eventBusType} />
            )}
            {/* contentView 內同時裝著 iframe 與畫記 canvas，一起被 transform，
                因此畫記與內容的相對位置在縮放／位移後仍然正確，不需額外換算。 */}
            <ExtendedPinchPanContainer
                containerWidth={canvasWidth}
                containerHeight={canvasHeight}
                extendedCanvas={canvasState.canvas}
            >
                <div ref={contentView} className={styles.contentView}>
                    {children}
                    {svgContent && !canvasState.isActive && (
                    <div
                        className={styles.svgContent}
                        dangerouslySetInnerHTML={{
                        __html: getCanvasSvg(svgContent)
                        }}
                    />
                    )}
                    {isContentInit && <ExtendedContentCanvas {
                        ...{ canvasState, canvasDispatch, canvasWidth, canvasHeight }
                    } />}
                </div>
            </ExtendedPinchPanContainer>
            {/* zoomEnabled：HTML 視窗沒有「切頁」概念，不能借用 shouldSplited
                （那會連帶叫出上下頁按鈕），故以獨立旗標開啟三顆縮放按鈕。 */}
            <ExtendedContentTools {...{ eventBusType, canvasState, toolbarOpen, zoomEnabled: true }} />
        </div>
    );
};
